mutation DuplicateSalesDocument($input: SalesDocumentDuplicateInput!) {
    salesDocumentDuplicate(input: $input) {
        salesDocument {
            id
            modalUrl
        }
    }
}
